import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subheader col-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "データ診断機能")
], -1)
const _hoisted_4 = { class: "subheader-block ml-auto demo" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-redo-alt mr-1" }, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-xl-12" }
const _hoisted_10 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "一覧"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1)
const _hoisted_12 = {
  class: "panel-container show",
  id: "panel-list"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1)
const _hoisted_14 = {
  class: "panel-content",
  style: {"height":"540px","overflow":"auto"}
}
const _hoisted_15 = {
  key: 0,
  class: "gtablecell"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 1,
  class: "gtablecell"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dl())),
          disabled: _ctx.btnDisable,
          class: "btn btn-success waves-effect waves-themed"
        }, [
          _hoisted_6,
          _createTextVNode("Excel出力 ")
        ], 8, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-info waves-effect waves-themed",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getlist(1)))
        }, [
          _hoisted_7,
          _createTextVNode("更新 ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_vue_good_table, {
                ref: "vgt",
                mode: "remote",
                onPageChange: _ctx.onPageChange,
                onSortChange: _ctx.onSortChange,
                "max-height": "500px",
                columns: _ctx.columns,
                rows: _ctx.delegate.items,
                "sort-options": {
                  enabled: false,
                },
                "pagination-options": {
                  enabled: false,
                  // perPageDropdownEnabled: false,
                  // enabled: true,
                  // jumpFirstOrLast: false,
                  // nextLabel: '次へ',
                  // prevLabel: '前へ',
                  // mode: 'pages',
                  // ofLabel: '/',
                  // pageLabel: '',
                },
                totalRows: _ctx.delegate.pager.maxcount
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == 'links')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.formattedRow[props.column.field], (item) => {
                          return (_openBlock(), _createElementBlock("a", {
                            href: item.url,
                            key: item.id,
                            class: _normalizeClass(["btn btn-xs waves-effect waves-themed mr-2 mb-1", {
                        'btn-primary': item.url.includes('seikyusyocreate'),
                        'btn-info': item.url.includes('jyutyuinput'),
                      }]),
                            target: "_blank"
                          }, [
                            (item.url.includes('seikyusyocreate'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" 請求No," + _toDisplayString(item.url.split("=")[1]), 1)
                                ], 64))
                              : (item.url.includes('jyutyuinput'))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" 受注番号," + _toDisplayString(item.url.split("=")[1]), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(item.url), 1)
                                  ], 64))
                          ], 10, _hoisted_16))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_18,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_19
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}